var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient-load"},[_c('div',{staticClass:"shine-line"}),_c('img',{attrs:{"src":_vm.patientSkeleton}})])
}
var staticRenderFns = []

export { render, staticRenderFns }